module.exports = __webpack_public_path__ + "images/marketing/contactform-integration.png";